import { makeStyles } from '@fluentui/react-components';

export const useFilterComponentStyles = makeStyles({
  checkbox: {
    display: 'flex',
    gap: '8px',
    '& .rl7ci6d': {
      border: '1px solid', // Lighter border color
      borderRadius: '2px', // Optional: Rounded corners
    },
  },
  primaryButton: {
    color: 'white',
    background: '#0F6CBD',
    height: '32px',
    fontFamily: 'sans-serif',
    fontSize: 'small',
    borderRadius: '4px',
  },
  secondaryButton: {
    height: '32px',
    fontFamily: 'sans-serif',
    fontSize: 'small',
    borderRadius: '4px',
    border: '1px solid',
  },

  switchButtonStyle: {
    color: '#616161',
    '& .r1c3hft5': {
      borderRadius: '10px',
    },
    '& .fruq291': {
      paddingLeft: '10px',
    },
  },

  filterComponentContainerStyle: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  selectedFilterContainerStyle: {
    display: 'flex',
    alignItems: 'center',
  },
  selectedFilterStyle: {
    paddingLeft: '16px',
    fontWeight: '500',
    fontSize: '14px',
  },
  selectedFilterRemoveButtonStyle: {
    paddingLeft: '0px',
  },
  filterButtonContainerStyle: {
    backgroundColor: '#f3f2f1',
    color: '#323130',
    border: '1px solid #d2d0ce',
    borderRadius: '20px',
    padding: '5px',
  },
  filterButtonStyle: { fontWeight: '500', fontSize: '14px' },
  filterOptionsDropdownStyle: {
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    border: '1px solid #d2d0ce',
    borderRadius: '5px',
    padding: '16px',
    backgroundColor: '#ffffff',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '6px',
  },
  filterItemStyle: { padding: '12px 16px', cursor: 'pointer' },
  selectedFilterOptionMenuStyle: {
    display: 'flex',
    flexDirection: 'column',
    width: '600px',
  },
  selectedFilterOptionHeaderStyle: { display: 'flex', justifyContent: 'space-between', marginBottom: '16px' },
  selectedFilterButtonStyle: { fontWeight: '600', fontFamily: 'sans-serif', fontSize: '18px' },
  clearAllButtonStyle: { color: '#115EA3', fontFamily: 'sans-serif', fontSize: '14px' },
  searchAndToggleContainerStyle: { display: 'flex', paddingBottom: '8px' },
  searchBarStyle: { border: '1px solid #d2d0ce', borderRadius: '4px', padding: '8px', flex: '2' },
  toggleButtonStyle: { display: 'flex', alignItems: 'center', paddingLeft: '10px', paddingRight: '20px' },
  filterOptionsContainerStyle: { maxHeight: '150px', overflowY: 'auto', marginBottom: '16px' },
  applyAndCancelContainerStyle: { display: 'flex', justifyContent: 'flex-end', gap: '10px' },
});
